module.exports = __webpack_public_path__ + "static/media/saanvi_shet.4ae73b18.png";